module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('row', _vm._l((_vm.preconditions), function(precondition) {
    return _c('div', {
      key: precondition.id,
      staticClass: "col-lg-3 col-xs-6"
    }, [_c('va-small-box', {
      attrs: {
        "color": _vm.customClass(precondition.status, 'pre'),
        "icon": _vm.customClass(precondition.preCondition, 'icon'),
        "title": _vm.$t(precondition.preCondition),
        "description": _vm.getDescriptions(precondition.status, precondition.preCondition),
        "moreText": _vm.$t(_vm.customClass(precondition.duration, 'duration'))
      },
      on: {
        "more-click": _vm.clickToSmallBox
      }
    })], 1)
  }), 0), _vm._v(" "), _c('task', {
    attrs: {
      "patientInfo": _vm.patientInfo,
      "name": "bsForward",
      "userType": _vm.userType
    }
  }), _vm._v(" "), _c('prescription', {
    attrs: {
      "patientInfo": _vm.patientInfo,
      "name": "bsMedicine"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "well profile"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-female"
  }), _vm._v(_vm._s(_vm.patientInfo.name) + "    "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.showTrend(_vm.patientInfo.trend))
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('contactNumber')) + ": ")]), _c('a', {
    attrs: {
      "href": ("tel:+" + (_vm.patientInfo.contactNumber))
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile fa-2x"
  }), _vm._v(" " + _vm._s(_vm.patientInfo.contactNumber))]), _vm._v("   |  "), _c('a', {
    attrs: {
      "href": ("tel:+" + (_vm.patientInfo.enterBy))
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile fa-2x"
  }), _vm._v(" " + _vm._s(_vm.patientInfo.enterBy))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('address')) + ": ")]), _vm._v(_vm._s(_vm.patientInfo.locationName) + " " + _vm._s(_vm.patientInfo.address) + " " + _vm._s(_vm.patientInfo.city) + " " + _vm._s(_vm.patientInfo.zipcode) + " " + _vm._s(_vm.patientInfo.state) + " ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('physical')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "tags"
  }, [_vm._v(_vm._s(_vm.$t('heightData')[[_vm.patientInfo.height]]))]), _vm._v(" "), _c('span', {
    class: _vm.customClass(_vm.patientInfo.wight)
  }, [_vm._v(_vm._s(_vm.$t('weightData')[[_vm.patientInfo.wight]]))])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('age')) + ": ")]), _vm._v(" "), _c('span', {
    class: _vm.customClass(_vm.patientInfo.yob, 'age')
  }, [_vm._v(_vm._s(new Date().getFullYear() - _vm.patientInfo.yob) + "  " + _vm._s(_vm.$t('years')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-center"
  }, [_c('figure', [_c('figcaption', {
    staticClass: "ratings"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('risk')) + ":" + _vm._s(_vm.$t('riskFactor')[[_vm.calRiskFactor(_vm.patientInfo.riskFactor)]]) + "\n                           " + _vm._s(_vm.$t('symptom')) + ":" + _vm._s(_vm.$t('riskFactor')[[_vm.calRiskFactor(_vm.patientInfo.currentRating)]]) + "\n                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 divider text-center"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_c('h4', [_c('strong', [_vm._v(" " + _vm._s(_vm.moment(_vm.patientInfo.insertTime).startOf('hour').fromNow()))])]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('registerDate')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(3, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" " + _vm._s(_vm.$t('consultant')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.patientInfo.updateTime > 0 ? _vm.moment(_vm.patientInfo.updateTime).startOf('hour').fromNow() : 'Never'))])]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('lastUpdate')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-block",
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(4, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-ambulance"
  }), _vm._v(" " + _vm._s(_vm.$t('ambulance')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('lastUpdate')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group dropup btn-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(5, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" " + _vm._s(_vm.$t('filed_staff')) + "  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 emphasis"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('lastUpdate')))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group dropup btn-block"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openTaskFrom(6, $event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" " + _vm._s(_vm.$t('prescribtion')) + "  ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Symptoms')))])]), _vm._v(" "), (_vm.chartData.data.datasets.length > 0) ? _c('va-chart', {
    attrs: {
      "chart-config": _vm.chartData
    }
  }) : _c('div', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x text-primary",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('row', [_c('section', {
    staticClass: "col-lg-6 connectedSortable ui-sortable"
  }, [_c('va-chat-box', {
    attrs: {
      "patient": _vm.patientInfo
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "col-lg-6 connectedSortable ui-sortable"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('Rooms'), _vm._v(" "), _c('Video', {
    attrs: {
      "username": _vm.patientInfo.name
    }
  }), _vm._v(" "), _c('Logs')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('strong', [_vm._v("43")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('strong', [_vm._v("43")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-970477a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PatientDetails.vue
// module id = 737
// module chunks = 1